import { Card, CardBody, SimpleGrid, Text, Box } from '@chakra-ui/react';
import { format } from 'date-fns';
import { translate } from '../../../i18n';
import { CourtScheduleConfigurationDto } from '../../../models/court/dto/configuration.dto';

type CourtConfigurationListProps = {
    configurations: CourtScheduleConfigurationDto[];
};

export const CourtConfigurationList = ({ configurations }: CourtConfigurationListProps) => {
    return (
        <SimpleGrid columns={1} spacing={4}>
            {configurations.map((config) => (
                <Card key={config.id}>
                    <CardBody>
                        <Text fontSize="xl" fontWeight="bold" mb={4}>
                            {config.isAppliedToAllTime
                                ? translate('court_configuration.form.is_applied_to_all_time')
                                : `${format(new Date(config.startDate), 'PP')} - ${format(new Date(config.endDate), 'PP')}`}
                        </Text>
                        {config.rules.map((rule, index) => (
                            <Box key={index} mb={4} p={4} borderWidth="1px" borderRadius="md">
                                <SimpleGrid columns={2} spacing={4}>
                                    <Box>
                                        <Text fontWeight="bold">{translate('court_configuration.form.price')}</Text>
                                        <Text>{rule.price} {rule.currency}</Text>
                                    </Box>
                                    <Box>
                                        <Text fontWeight="bold">{translate('court_configuration.form.price_duration')}</Text>
                                        <Text>{rule.priceDuration} {translate('court_configuration.form.minutes')}</Text>
                                    </Box>
                                    <Box>
                                        <Text fontWeight="bold">{translate('court_configuration.form.start_time')}</Text>
                                        <Text>{format(new Date(rule.startTime), 'p')}</Text>
                                    </Box>
                                    <Box>
                                        <Text fontWeight="bold">{translate('court_configuration.form.end_time')}</Text>
                                        <Text>{format(new Date(rule.endTime), 'p')}</Text>
                                    </Box>
                                </SimpleGrid>
                            </Box>
                        ))}
                    </CardBody>
                </Card>
            ))}
        </SimpleGrid>
    );
};